import { inject, injectable } from 'inversify'
import { PlayerModule } from '@/app/api';
import { QuestionAttemptServiceSymbol, QuestionAttemptService } from './service'

@injectable()
export class QuestionAttemptPlayerModule implements PlayerModule {
  readonly name = 'question-attempt'
  
  constructor(
    @inject(QuestionAttemptServiceSymbol)
    private questionAttemptService: QuestionAttemptService) {}

  start(): void {
    this.questionAttemptService.start()
  }

  reset(): void {
  }

  async stop() {
    await this.questionAttemptService.stop()
  }
}
